import type { PayoutState } from 'models/payout';

export const CREATE_MANUAL_PAYOUT_TEST_ID = 'create-manual-payout';
export const PAYOUT_REQUEST_TITLE_TEST_ID = 'title-payout-requests';
export const PAYOUT_REQUEST_TABLE_TEST_ID = 'payout-requests-table';
export const PAYOUT_REQUEST_DETAILS_TEST_ID = 'payout-request-details';

export const PAYOUTS_ACCOUNT_FILTER_TEST_ID = 'payouts-account-filter';
export const PAYOUTS_CURRENCY_FILTER_TEST_ID = 'payouts-currency-filter';
export const PAYOUTS_AMOUNT_FILTER_TEST_ID = 'payouts-amount-filter';
export const PAYOUTS_AMOUNT_FROM_FILTER_TEST_ID = 'payouts-amount-from-filter';
export const PAYOUTS_AMOUNT_TO_FILTER_TEST_ID = 'payouts-amount-to-filter';
export const PAYOUTS_APPLY_AMOUNT_BUTTON_TEST_ID =
  'payouts-apply-amount-button';
export const PAYOUTS_STATUS_FILTER_TEST_ID = 'payouts-status-filter';
export const PAYOUTS_CLEAR_FILTERS_BUTTON_TEST_ID =
  'payouts-clear-filters-button';

export const PAYOUTS_UNIQUE_REFERENCE = 'unique-reference';

export const PAYOUT_STATUSES: Array<PayoutState> = [
  {
    id: 'received',
    value: 'received',
    order: 1,
    label: 'Received',
    style: {
      color: 'bg-status-neutral',
      activeColor: 'bg-status-neutral-active',
      hover: 'hover:bg-status-neutral-active'
    }
  },
  {
    id: 'processing',
    value: 'processing',
    order: 2,
    label: 'Processing',
    style: {
      color: 'bg-status-processing',
      activeColor: 'bg-status-processing-active',
      hover: 'hover:bg-status-processing-active'
    }
  },
  {
    id: 'rejected',
    value: 'rejected',
    order: 3,
    label: 'Rejected',
    style: {
      color: 'bg-status-negative',
      activeColor: 'bg-status-negative-active',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: 'pending',
    value: 'pending',
    order: 4,
    label: 'Pending',
    style: {
      color: 'bg-status-pending',
      activeColor: 'bg-status-pending-active',
      hover: 'hover:bg-status-pending-active'
    }
  },
  {
    id: 'action_required',
    value: 'action_required',
    order: 5,
    label: 'Action Required',
    style: {
      color: 'bg-status-action-required',
      activeColor: 'bg-status-action-required-active',
      hover: 'hover:bg-status-action-required-active'
    }
  },
  {
    id: 'completed',
    value: 'completed',
    order: 6,
    label: 'Completed',
    style: {
      color: 'bg-status-completed',
      activeColor: 'bg-status-completed-active',
      hover: 'hover:bg-status-completed-active'
    }
  },
  {
    id: 'returned',
    value: 'returned',
    order: 7,
    label: 'Returned',
    style: {
      color: 'bg-status-returned',
      activeColor: 'bg-status-returned-active',
      hover: 'hover:bg-status-returned-active'
    }
  }
];
